import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App' 
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import jaLocale from 'date-fns/locale/ja';
import theme from './styles/theme';
import './index.css';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Provider } from 'react-redux';
import { store } from './apis/store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // https://github.com/atlassian/react-beautiful-dnd/issues/2396
  // <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={jaLocale}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <BrowserRouter>
              <App />
          </BrowserRouter>
        </Provider>
      </ThemeProvider>
    </LocalizationProvider>
  // </React.StrictMode>
);

reportWebVitals();
